module.exports = __webpack_public_path__ + "img/grunt_small.485cd91b.png";